// extracted by mini-css-extract-plugin
module.exports = {"nav-desk":"styles_nav-desk__1evGH","title":"styles_title__g4Jx0"};